import { API_SERVICES } from "@packages/api/types";
import store from "@packages/store";
import jwtDecode from "jwt-decode";


export default {
    API_SERVICE: API_SERVICES.AUTH,

    url(path = "") {
        return `${this.API_SERVICE}${this.apiUrl}${path}`;
    },

    userUrl({ userId, path = "" } = {}) {
        const userUrl = userId ? `/user/${userId}` : this.USER_URL();

        return `${this.API_SERVICE}${userUrl}${this.apiUrl}${path}`;
    },

    adminUrl(path = "") {
        return `${this.API_SERVICE}${this.urlAdmin}${path}`;
    },

    USER_URL() {
        const loggedUserData = store.state.users.user;
        const adminUserData =  store.state.users.admin;

        const userId = loggedUserData ? loggedUserData.id : jwtDecode(adminUserData.token).userId;
        
        if (!userId) throw Error("User not logged in");

        return `/user/${userId}`;
    },
};
